import React, { useEffect } from "react";
import { SEO } from "../components/SEO";
import { Play, TrendingUp } from "lucide-react";

export const CasosSucesso = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white min-h-screen pb-20">
      <SEO 
        title="Casos de Sucesso | RosTech" 
        description="Conheça oficinas que transformaram sua gestão e multiplicaram seus lucros com o ERP RosTech."
        canonicalUrl="/clientes"
      />

      <section className="pt-32 pb-20 bg-slate-900 border-b border-slate-800 text-white overflow-hidden relative">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-20 pointer-events-none">
          <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-blue-600 blur-[120px]"></div>
          <div className="absolute -bottom-[20%] -left-[10%] w-[70%] h-[70%] rounded-full bg-emerald-600 blur-[120px]"></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 relative z-10 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-500/20 text-blue-300 text-sm font-bold tracking-wide uppercase mb-8 border border-blue-500/20">
            <TrendingUp className="w-4 h-4" /> Resultados Reais
          </div>
          <h1 className="text-5xl md:text-7xl font-black text-white mb-8 tracking-tight">
            oficinas que <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-emerald-400">cresceram</span><br />
            com a RosTech.
          </h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto mb-12 leading-relaxed">
            Nós não vendemos apenas tecnologia. Nós entregamos resultados. Veja como centenas de oficinas mecânicas organizaram a casa, reduziram custos e multiplicaram seus lucros.
          </p>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="relative group rounded-3xl overflow-hidden shadow-2xl border border-slate-200">
              <img src="https://images.unsplash.com/photo-1590212359571-0a6aa0271701?auto=format&fit=crop&q=80&w=1200" alt="Oficina de Sucesso" className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-colors flex items-center justify-center">
                <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-700 transition shadow-[0_0_30px_rgba(37,99,235,0.5)]">
                  <Play className="w-8 h-8 text-white ml-2" />
                </div>
              </div>
            </div>
            <div>
              <div className="text-sm font-bold tracking-widest uppercase text-blue-600 mb-4">Destaque</div>
              <h2 className="text-4xl font-black text-slate-900 mb-6 leading-tight">
                "Saímos de R$40 mil para R$150 mil por mês em menos de um ano de uso."
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed mb-8">
                A Oficina do João, em Campinas/SP, sofria com orçamentos perdidos, falta de controle de estoque e peças sumindo. Após implementar o ERP RosTech, o cenário mudou drasticamente: o controle absoluto das ordens de serviço e do financeiro permitiu que a equipe focasse em vender mais e melhor.
              </p>
              
              <div className="grid grid-cols-2 gap-8 mb-8">
                <div>
                  <div className="text-4xl font-black text-emerald-600 mb-2">+ 275%</div>
                  <div className="text-sm font-bold text-slate-500 uppercase">Crescimento de Faturamento</div>
                </div>
                <div>
                  <div className="text-4xl font-black text-blue-600 mb-2">- 40%</div>
                  <div className="text-sm font-bold text-slate-500 uppercase">Redução de Custos com Peças</div>
                </div>
              </div>

              <div className="flex items-center gap-4 border-t border-slate-100 pt-8">
                <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&q=80&w=150" alt="João Marcos" className="w-14 h-14 rounded-full object-cover" />
                <div>
                  <div className="font-bold text-slate-900">João Marcos Silva</div>
                  <div className="text-sm text-slate-500">Fundador, Oficina do João</div>
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-16">
             <div className="bg-slate-50 rounded-2xl p-8 border border-slate-100">
               <img src="https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&q=80&w=600" alt="Auto Center São Paulo" className="w-full h-48 object-cover rounded-xl mb-6" />
               <h3 className="font-bold text-2xl mb-4 text-slate-900">Auto Center São Paulo</h3>
               <p className="text-slate-600 mb-6">"O checklist digita revolucionou nosso atendimento. O cliente recebe fotos das peças desgastadas no WhatsApp e aprova o orçamento na hora. Aumentamos o ticket médio em 35%."</p>
               <div className="font-bold text-slate-900">Marcos Andrade</div>
             </div>
             
             <div className="bg-slate-50 rounded-2xl p-8 border border-slate-100">
               <img src="https://images.unsplash.com/photo-1632823465306-eddcadd2c47c?auto=format&fit=crop&q=80&w=600" alt="Mecânica Especializada" className="w-full h-48 object-cover rounded-xl mb-6" />
               <h3 className="font-bold text-2xl mb-4 text-slate-900">Mecânica Especializada</h3>
               <p className="text-slate-600 mb-6">"Tínhamos problemas com notas fiscais e o contador sempre reclamava. Com a RosTech o controle financeiro e emissão de notas ficaram transparentes e 100% integrados."</p>
               <div className="font-bold text-slate-900">Ana Beatriz</div>
             </div>
          </div>
        </div>
      </section>
    </div>
  );
};
